.filePicker {
  display: block;
}